import resolveRequest from '../../utils/resolveRequest.js'
import axios from 'axios'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async (campaignId) => {
    const URL = SERVER_PATH + apiEndpoints.campaigns + `/${campaignId}` + apiEndpoints.clone
    return resolveRequest(axios.post(URL, null, { withCredentials: true }))
}
